import styled from 'styled-components'

import { media, mediaMax } from 'styles/media'

const ITEM_SIDE_PADING_MOBILE = 16
const ITEM_SIDE_PADDING_DESKTOP = 14

type GridItemProps = {
  widthOverride?: {
    md?: string
    lg?: string
    xxxl?: string
  }
}

export const defaultItemsPerBreakpoint = {
  md: 2,
  lg: 3,
  xxxl: 4,
} as const

export const GridItem = styled.div.attrs({
  className: 'qa-grid-item',
})<GridItemProps>`
  box-sizing: border-box;
  padding: 0 8px;
  padding: 0 ${ITEM_SIDE_PADING_MOBILE}px;

  ${media.md`
    padding: 0 ${ITEM_SIDE_PADDING_DESKTOP}px;
  `}

  width: 100%;

  /*
    Default widths by breakpoint; can be overridden in other contexts to suit specific use cases
    e.g. a grid that ocupies only part of a screen.
  */

  ${media.md<GridItemProps>`
    width: ${({ widthOverride }) =>
      widthOverride?.md || `${100 / defaultItemsPerBreakpoint.md}%`};
  `}

  ${media.lg<GridItemProps>`
    width: ${({ widthOverride }) =>
      widthOverride?.lg || `${100 / defaultItemsPerBreakpoint.lg}%`};
  `}

  ${media.xxxl<GridItemProps>`
    width: ${({ widthOverride }) =>
      widthOverride?.xxxl || `${100 / defaultItemsPerBreakpoint.xxxl}%`};
  `}
`

type GridOptions = {
  mobileWidthOffset?: boolean
}

export const Grid = styled.div<GridOptions>`
  display: flex;
  flex-wrap: wrap;

  ${mediaMax.md<GridOptions>`
    ${({ mobileWidthOffset }) =>
      mobileWidthOffset &&
      `
      margin: 0 -${ITEM_SIDE_PADING_MOBILE}px;
    `}
  `}

  ${media.md`
    margin: 0 -${ITEM_SIDE_PADDING_DESKTOP}px;
  `}
`
